import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from './styles';
import Logo from '../../assets/images/home/logo.png';
import LogoFooter from '../../assets/images/home/logo-footer.png';
import Phones from '../../assets/images/home/phones.png';
import PhonePromoter from '../../assets/images/home/phone-promoter.png';
import ButtonApple from '../../assets/images/home/store-apple.png';
import ButtonGoogle from '../../assets/images/home/store-google.png';
import IconFacebook from '../../assets/images/home/icon-facebook.png';
import IconInstagram from '../../assets/images/home/icon-instagram.png';
import How1 from '../../assets/images/home/how-1.png';
import How2 from '../../assets/images/home/how-2.png';
import How3 from '../../assets/images/home/how-3.png';

const Home = () => (
  <Container>
    <header>
      <img src={Logo} alt="Divulgaí" />
      <ul className="menu">
        <li>
          <Link to="/panel/create-event">Criar evento</Link>
        </li>
        <li>
          <Link to="/panel" className="login">Login</Link>
        </li>
      </ul>
    </header>
    <section className="section-main">
      <div className="wrapper">
        <div className="image">
          <img src={Phones} alt="Aplicativo para produtores de eventos" />
        </div>
        <div className="text">
          <h1>Divulgue seu Evento</h1>
          <p>
            Cadastre seu evento, agende publicações e garanta que seus divulgadores
            estão compartilhando o conteúdo da maneira correta. Tudo isso de forma
            simples e prática.
          </p>
          <Link to="/panel/create-event">Cadastrar evento</Link>
        </div>
      </div>
    </section>
    <section className="section-promoter">
      <div className="wrapper">
        <div className="text">
          <h2>Praticidade pro divulgador</h2>
          <h3>
            O divulgador conta com um aplicativo próprio para acompanhar as novidades
            e publicações do evento
          </h3>
          <p>
            Sempre que um evento receber uma nova publicação o divulgador será notificado
            e poderá compartilhar de maneira simples, diretamente pelo app. Além disso é
            possível procurar novos eventos para divulgar e muito mais.
          </p>
          <div className="downloads">
            <a href="https://apps.apple.com/br/app/divulgaí/id1445495595" target="_blank" rel="noopener noreferrer">
              <img src={ButtonApple} alt="Download na App Store" />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.divulgaiapp" target="_blank" rel="noopener noreferrer">
              <img src={ButtonGoogle} alt="Download na Google Play" />
            </a>
          </div>
        </div>
        <div className="image">
          <img src={PhonePromoter} alt="Aplicativo para divulgadores de eventos" />
        </div>
      </div>
    </section>
    <section className="section-how">
      <div className="wrapper">
        <h1>Como funciona</h1>
        <div className="process">
          <div className="item">
            <img src={How1} alt="Cadastre" />
            <span>Cadastre</span>
            <p>
              Cadastre seu evento e agende as publicações que serão compartilhadas pelos
              divulgadores no Instagram
            </p>
          </div>
          <div className="item">
            <img src={How2} alt="Convide" />
            <span>Convide</span>
            <p>
              Convide os divulgadores, dê advertências e avalie suas participações.
            </p>
          </div>
          <div className="item">
            <img src={How3} alt="Controle" />
            <span>Controle</span>
            <p>
              Saiba quais divulgadores compartilharam corretamente e tenha um relatório
              completo da divulgação.
            </p>
          </div>
        </div>
      </div>
    </section>
    <footer>
      <a className="mail" href="mailto:contato@divulgai.app">contato@divulgai.app</a>
      <img className="logo-footer" src={LogoFooter} alt="Divulgaí - Divulgue o seu evento" />
      <div className="social">
        <a href="http://facebook.com/divulgaiapp" target="_blank" rel="noopener noreferrer">
          <img src={IconFacebook} alt="Facebook do Divulgaí" />
        </a>
        <a href="http://instagram.com/divulgai.app" target="_blank" rel="noopener noreferrer">
          <img src={IconInstagram} alt="Instagram do Divulgaí" />
        </a>
      </div>
    </footer>
  </Container>
);
export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home/index.js